import { render, staticRenderFns } from "./PostFeed.vue?vue&type=template&id=84a5721c"
import script from "./PostFeed.vue?vue&type=script&lang=ts"
export * from "./PostFeed.vue?vue&type=script&lang=ts"
import style0 from "./PostFeed.vue?vue&type=style&index=0&id=84a5721c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports